(function () {
  'use strict';

  if (window.qnProductCardDelegatedInitDone) return;
  window.qnProductCardDelegatedInitDone = true;

  function formatCompare(compareValue) {
    return compareValue && compareValue.trim() !== '';
  }

  function updatePrice(card, button) {
    if (!card || !button) return;

    const currentPrice = card.querySelector('[data-price-current]');
    const comparePrice = card.querySelector('[data-price-compare]');
    const addBtn = card.querySelector('[data-quick-add]');

    if (!currentPrice || !addBtn) return;

    const price = button.getAttribute('data-variant-price') || '';
    const compare = button.getAttribute('data-variant-compare') || '';
    const variantId = button.getAttribute('data-variant-id') || '';

    currentPrice.textContent = price;
    addBtn.setAttribute('data-variant-id', variantId);

    currentPrice.classList.remove('qn-product-card__price-regular', 'qn-product-card__price-sale');

    if (formatCompare(compare)) {
      currentPrice.classList.add('qn-product-card__price-sale');

      if (comparePrice) {
        comparePrice.textContent = compare;
        comparePrice.hidden = false;
      }
    } else {
      currentPrice.classList.add('qn-product-card__price-regular');

      if (comparePrice) {
        comparePrice.textContent = '';
        comparePrice.hidden = true;
      }
    }
  }

  async function quickAdd(button) {
    if (!button || button.disabled) return;

    const variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    const originalText = button.dataset.originalText || button.textContent || 'Agregar';
    button.dataset.originalText = originalText;

    button.disabled = true;
    button.classList.add('is-loading');
    button.textContent = 'Agregando...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1
        })
      });

      if (!response.ok) throw new Error('Error al agregar');

      await response.json();

      button.classList.remove('is-loading');
      button.classList.add('is-added');
      button.textContent = 'Agregado';

      const card = button.closest('[data-product-card]');
      const cartContext =
        button.getAttribute('data-cart-context') ||
        (card && card.getAttribute('data-card-context')) ||
        'natural';

      if (cartContext === 'home') {
        document.dispatchEvent(new CustomEvent('qh:cart:open'));
      } else {
        document.dispatchEvent(new CustomEvent('qn:cart:open'));
      }

      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      setTimeout(function () {
        button.classList.remove('is-added');
        button.disabled = false;
        button.textContent = originalText;
      }, 1200);
    } catch (error) {
      button.classList.remove('is-loading');
      button.classList.add('is-error');
      button.textContent = 'Error';

      setTimeout(function () {
        button.classList.remove('is-error');
        button.disabled = false;
        button.textContent = originalText;
      }, 1200);
    }
  }

  document.addEventListener('click', function (event) {
    const variantBtn = event.target.closest('[data-variant-option]');
    if (variantBtn) {
      const card = variantBtn.closest('[data-product-card]');
      if (!card || variantBtn.disabled) return;

      const buttons = card.querySelectorAll('[data-variant-option]');
      buttons.forEach(function (btn) {
        btn.classList.remove('qn-product-card__variant--active');
      });

      variantBtn.classList.add('qn-product-card__variant--active');
      updatePrice(card, variantBtn);
      return;
    }

    const addBtn = event.target.closest('[data-quick-add]');
    if (addBtn) {
      event.preventDefault();
      quickAdd(addBtn);
    }
  });
})();
